import React from "react";

export const StatBox = ({ label, value }) => (
  <div className="bg-gray-50 rounded-lg px-4 py-2 text-center border border-gray-100">
    <div className="text-[10px] text-gray-500 uppercase tracking-wide">{label}</div>
    <div className="text-lg font-bold text-gray-900">{value ?? "—"}</div>
  </div>
);

const getZoneDescription = (zone, bats = "R") => {
  const isLefty = bats?.toUpperCase().startsWith("L");
  
  const zoneMapRHH = {
    1: "inside high",
    2: "middle high",
    3: "outside high",
    4: "inside middle",
    5: "middle middle",
    6: "outside middle",
    7: "inside low",
    8: "middle low",
    9: "outside low",
  };
  
  const zoneMapLHH = {
    1: "outside high",
    2: "middle high",
    3: "inside high",
    4: "outside middle",
    5: "middle middle",
    6: "inside middle",
    7: "outside low",
    8: "middle low",
    9: "inside low",
  };
  
  const zoneMap = isLefty ? zoneMapLHH : zoneMapRHH;
  return zoneMap[zone] || "";
};

const formatZoneDescriptions = (zones, isHot, bats) => {
  if (!zones || zones.length === 0) return "";
  
  const descriptions = zones.map(z => getZoneDescription(z, bats)).filter(Boolean);
  if (descriptions.length === 0) return "";
  
  const prefix = isHot ? "Likes: " : "Struggles with: ";
  return prefix + descriptions.join(", ");
};

export const StrikeZoneGrid = ({ selectedZones = [], label, isHot = true, bats = "R" }) => {
  const zones = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  
  return (
    <div className="flex flex-col items-center">
      <span className="text-[10px] text-gray-500 mb-1 font-medium">{label}</span>
      <div className="grid grid-cols-3 gap-0.5 bg-gray-300 p-0.5 rounded">
        {zones.map((zone) => {
          const isSelected = selectedZones.includes(zone);
          return (
            <div 
              key={zone} 
              className={`w-6 h-6 flex items-center justify-center text-[9px] font-semibold rounded-sm ${
                isSelected 
                  ? (isHot ? 'bg-red-500 text-white' : 'bg-blue-500 text-white') 
                  : 'bg-white text-gray-400'
              }`}
            >
              {zone}
            </div>
          );
        })}
      </div>
      <svg width="50" height="16" viewBox="0 0 50 16" className="mt-1">
        <path 
          d="M5 0 L45 0 L50 8 L25 16 L0 8 Z" 
          fill="#d1d5db" 
        />
      </svg>
      {selectedZones.length > 0 && (
        <p className="text-[9px] text-gray-600 mt-1 text-center max-w-[80px]">
          {formatZoneDescriptions(selectedZones, isHot, bats)}
        </p>
      )}
    </div>
  );
};

export const PageFooter = ({ pageNumber, totalPages }) => (
  <div className="absolute bottom-4 left-8 right-8 flex justify-between items-center pt-3 border-t border-gray-100">
    <span className="text-[10px] text-gray-400">
      Generated by D3 Dashboard • {new Date().toLocaleDateString()}
    </span>
    <span className="text-[10px] text-gray-500">
      Page {pageNumber} of {totalPages}
    </span>
  </div>
);
